<template>
  <div class="header-row">
    <div class="filters">
      <TableFilter
        v-for="filter of availableFilters"
        :key="filter.id"
        :active-filters="filters"
        :disable="shouldDisable(filter.value)"
        :value="filter.value"
        :label="filter.label"
        @filter="$emit('filter', filter.value)"
      />
    </div>

    <div class="buttons">
      <q-btn size="sm" color="tertiary" @click="$emit('open-modal')">
        Settings for new subscriptions
      </q-btn>
      <q-btn :disable="isSaveBtnDisabled" :loading="isSaveBtnLoading" size="sm" color="green" @click="onSave"
        >Save</q-btn
      >
    </div>
  </div>
</template>

<script>
import TableFilter from '@/reusable/TableFilter'

export default {
  components: {
    TableFilter
  },

  props: {
    filters: Array,
    isSaveBtnDisabled: Boolean,
    isSaveBtnLoading: Boolean
  },

  data: () => ({
    availableFilters: [
      { id: 1, label: 'Current', value: 'current' },
      { id: 2, label: 'Future', value: 'future' },
      { id: 3, label: 'One time purchase', value: 'oneTimePurchase' }
    ]
  }),

  methods: {
    shouldDisable(filter) {
      return this.filters.length === 1 && this.filters[0] === filter
    },
    onSave() {
      if (this.isSaveBtnLoading) return
      this.$emit('save')
    }
  }
}
</script>

<style lang="stylus" scoped>
.header-row {
  display grid
  grid-auto-flow column
  grid-template-columns 1fr 1fr
  padding 5px 15px
  align-items center

  .filters {
    display flex
  }

  .buttons {
    display grid
    grid-auto-flow column
    justify-content end
    gap 10px
  }
}
</style>
